import React, { useState } from 'react';
import { FaBriefcase, FaComment, FaUser } from 'react-icons/fa';
import { FaRightFromBracket } from 'react-icons/fa6';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Separator } from '@/components/ui/separator';

const ProfileBtn = ({ setModal }) => {
    const user = localStorage.getItem("user");
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    className="bg-white text-neutral-800 hover:bg-neutral-50 flex gap-2 items-center font-medium px-3 py-2 rounded-lg border border-neutral-200 shadow-sm"
                >
                    <FaUser />
                    <span>Profile</span>
                    <svg
                        className="ml-2 -mr-1 h-4 w-4 text-neutral-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                            clipRule="evenodd"
                        />
                    </svg>
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-72 p-3 rounded-lg shadow border border-neutral-100 bg-white">
                <div className="flex flex-col items-center gap-1">
                    <p className="text-neutral-700 font-semibold text-base truncate w-full text-center">
                        {user}
                    </p>
                    <Separator className="my-2 bg-neutral-100" />
                    <a href="/terms-and-conditions" className="flex gap-2 items-center w-full text-left px-3 py-2 hover:bg-neutral-100 rounded transition-colors text-neutral-700 text-sm">
                        <FaBriefcase /> Terms and Conditions
                    </a>
                    <a href="/feedback" className="flex gap-2 items-center w-full text-left px-3 py-2 hover:bg-neutral-100 rounded transition-colors text-neutral-700 text-sm">
                        <FaComment /> Feedback
                    </a>
                    <Button
                        variant="ghost"
                        className="w-full flex items-center gap-2 text-left px-3 py-2 text-red-500 hover:bg-red-50 font-medium rounded justify-start mt-1 text-sm"
                        onClick={() => setModal(true)}
                    >
                        <FaRightFromBracket className="text-red-400" />
                        Logout
                    </Button>
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default ProfileBtn;
